import { Box, Typography, Sheet, Button } from '@mui/joy';
import { Fire, ListChecks, Target, ClipboardText, ArrowRight } from '@phosphor-icons/react';

/**
 * Мини-статистика на главной: четыре числа и ссылка в раздел «Статистика».
 * stats = data из /testing/homepage-data/ (user_stats, streak).
 */
const NAVY = '#2A75D3';

function Stat({ id, icon: Icon, label, value }) {
    return (
        <Box data-testid={`stat-${id}`} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
            <Box sx={{ width: 36, height: 36, borderRadius: '10px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: `${NAVY}14`, color: NAVY }}>
                <Icon size={19} weight="duotone" />
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 20, fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.1 }}>{value}</Typography>
                <Typography level="body-xs" sx={{ color: 'text.tertiary', whiteSpace: 'nowrap' }}>{label}</Typography>
            </Box>
        </Box>
    );
}

export default function MiniStats({ stats, onDetails }) {
    const us = stats?.user_stats || {};
    const streak = stats?.streak?.current ?? 0;
    const total = us.total_answers ?? 0;
    const correct = us.correct_answers ?? 0;
    const accuracy = total > 0 ? `${Math.round((correct / total) * 100)}%` : '—';

    return (
        <Sheet variant="outlined" sx={{ p: { xs: 2, sm: 2.25 }, borderRadius: '16px', borderColor: 'divider', bgcolor: 'background.surface' }}>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr) auto' }, gap: { xs: 2, md: 1.5 }, alignItems: 'center' }}>
                <Stat id="streak" icon={Fire} label="дней подряд" value={streak} />
                <Stat id="questions" icon={ListChecks} label="вопросов решено" value={total.toLocaleString('ru-RU')} />
                <Stat id="accuracy" icon={Target} label="точность" value={accuracy} />
                <Stat id="tests" icon={ClipboardText} label="тестов завершено" value={us.completed_tests ?? 0} />
                <Button variant="plain" size="sm" onClick={onDetails} endDecorator={<ArrowRight size={14} />}
                    sx={{ gridColumn: { xs: '1 / -1', md: 'auto' }, justifySelf: { xs: 'start', md: 'end' }, color: 'text.secondary', fontWeight: 600, px: 1 }}>
                    Подробная статистика
                </Button>
            </Box>
        </Sheet>
    );
}
